export default "__VITE_ASSET__D$rXX4_A__"